import { SECOND } from 'constants/time';
import { NodeTrees } from 'ui/treeView';
import { useRestQuery } from 'utils/hooks/api/useRestQuery';

import { Channel, Device, List, MessageType, UserKey } from '../domain';

export const USER_METADATA_API = '/users/profiles/:userKey/getProfileDetails';

type UserMetadataQueryRequest = {
  userKey: UserKey;
};

export type UserMetadataQueryResponse = {
  email?: string;
  itblUserId: string;
  dataFields: NodeTrees;
  staticListsForUser: List[];
  channels: Channel[];
  messageTypes: MessageType[];
  userLists: List[];
  unsubscribedChannelIds: number[];
  unsubscribedMessageTypeIds: number[];
  subscribedMessageTypeIds: number[];
  pendingSubscriptionsMessageTypeIds: number[];
  userEventTypes: Set<string>;
  devices: Device[];
};

type UseUserMetadataQueryOptions = {
  userKey: UserKey;
};

export const useUserMetadataQuery = ({ userKey }: UseUserMetadataQueryOptions) =>
  useRestQuery<UserMetadataQueryResponse, UserMetadataQueryRequest>(
    USER_METADATA_API.replace(':userKey', userKey),
    undefined,
    {
      staleTime: 30 * SECOND,
    },
  );
